module.exports = __webpack_public_path__ + "static/media/ss9_preview.12f8c072.jpg";